// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    // Templates list
    enableAction: {
        id: 'actions.enable-action',
        defaultMessage: 'Enable this action'
    },
    nameYourAction: {
        id: 'actions.nameYourAction',
        defaultMessage: 'Name your action'
    },
    when: {
        id: 'actions.when',
        defaultMessage: 'WHEN'
    },
    while: {
        id: 'actions.while',
        defaultMessage: 'WHILE'
    },
    then: {
        id: 'actions.then',
        defaultMessage: 'THEN'
    },
    removeAction: {
        id: 'actions.remove-action',
        defaultMessage: 'Remove action'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/action-detail/intl.js